import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "@/utils/analytics";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    
    // Track page view for analytics
    analytics.pageView(pathname, document.title);
  }, [pathname]);

  return null;
};